export default __webpack_public_path__ + "static/pcPageBg-dcbc0a8433dcf331b5b755a2b07fad6b.jpg";